import React, { useEffect, useState } from "react";

let announceFn: ((message: string) => void) | null = null;

export const announce = (message: string) => {
  if (announceFn) {
    announceFn(message);
  }
};

const AccessibilityAnnouncer: React.FC = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    announceFn = (msg: string) => {
      // Clear first so the same message can be announced repeatedly
      setMessage("");

      window.setTimeout(() => {
        setMessage(msg);
      }, 50);
    };

    return () => {
      announceFn = null;
    };
  }, []);

  return (
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        clip: "rect(1px,1px,1px,1px)",
        whiteSpace: "nowrap",
      }}
    >
      {message}
    </div>
  );
};

export default AccessibilityAnnouncer;